/**
 * @param {Number} x
 * @param {Number} y
 * @returns {void}
 */
const scrollTo = (x, y) => {
  if (window.parentIFrame) {
    window.parentIFrame.scrollToOffset(0, y);
  } else {
    window.scrollTo(x, y);
  }
};

export default scrollTo;



// WEBPACK FOOTER //
// ./src/modules/scroll-to.js